import React, { Fragment } from "react";
import { Stack, Typography } from "@mui/material";
import { TagList } from "./tagList/TagList";
import { TagManagementCard } from "./TagManagementCard";
import { COLLAB_INTEREST_NSFW, COLLAB_INTEREST_SFW, CONTENT_INTEREST_NSFW, CONTENT_INTEREST_SFW, PLATFORMS_KEY, SOCIALS_KEY } from "../../../enums/generalEnums";

const TagManagementPage = () => {
  return (
    <Fragment>
      <Typography variant="h5" fontWeight={700} color="primary.main" mb={1.5}>Tag Management</Typography>
      <Stack gap={2}>
        <TagList />
        <TagManagementCard
          fetchTypes={[COLLAB_INTEREST_NSFW, COLLAB_INTEREST_SFW]}
          title={'Collab Interest'}
          defaultCategoryType={COLLAB_INTEREST_SFW}
        />
        <TagManagementCard
          fetchTypes={[CONTENT_INTEREST_NSFW, CONTENT_INTEREST_SFW]}
          title={'Content Interest'}
          defaultCategoryType={CONTENT_INTEREST_SFW}
        />
        <TagManagementCard
          fetchTypes={[SOCIALS_KEY]}
          title={'Socials'}
          defaultCategoryType={SOCIALS_KEY}
        />
        <TagManagementCard
          fetchTypes={[PLATFORMS_KEY]}
          title={'Platforms'}
          defaultCategoryType={PLATFORMS_KEY}
        />
      </Stack>
    </Fragment>
  );
};

export default TagManagementPage;